export const parseSolutionsWhoWeWorkWithContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'who-we-work-with');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};

  if (!fields.title) {
    return null;
  }

  const clients = [];

  for (let index = 1; index <= 20; index += 1) {
    const title = fields[`client-${index}-title`];
    if (!title) {
      break;
    }

    clients.push({
      title,
      description: fields[`client-${index}-description`] || '',
    });
  }

  if (clients.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    clients,
  };
};
